import { type RecipeVariantProps, cva } from "@/../styled-system/css";

import Skeleton from "../ui/Skeleton";

const avatarSkeletonRecipe = cva({
  base: {
    aspectRatio: "1",
    rounded: "full",
    flexShrink: "0",
  },
  variants: {
    size: {
      sm: { width: "44px" },
      md: { width: "56px" },
      lg: { width: "115px" },
    },
  },
});

type AvatarSkeletonProps = RecipeVariantProps<typeof avatarSkeletonRecipe>;

function AvatarSkeleton(size: AvatarSkeletonProps) {
  const avatarSkeletonCSS = avatarSkeletonRecipe.raw(size);
  return <Skeleton css={avatarSkeletonCSS} />;
}

export default AvatarSkeleton;
